/** @format */
import * as yup from "yup";



export const addproductlink = yup.object().shape({
  fileUpload: yup.mixed(), // Pass in the type of `fileUpload`
  name: yup.string().nullable(),
  url: yup.string().required(),
  important: yup.boolean(),

});
